export default {"src":"/_next/static/media/garden_or_backyard.c24a93fd.svg","height":100,"width":100};